import axios from "axios";
import { getUser, logOutUser, setSessionKey, getLocalKey, setReturnURL } from '../utils/commonfunction';
import Swal from "sweetalert2";
import { ROLE, SWAL_SETTINGS } from "./Constants";

const Axios = (options = {extraHeaders: {}}) => {
  // console.log(options , "page axios")
  const baseURL = process.env.REACT_APP_API_URL
  let headers = {
    language : getLocalKey('system_language') ? getLocalKey('system_language'): 'en'
  };
  
  try{
    const userData = getUser(options?.role);
    if(userData && userData.token){
      headers.Authorization = `Bearer ${userData.token}`;
    }else if(options.token){
      headers.Authorization = `Bearer ${options.token}`;
    }

    console.log(headers, '-------------headers');

    if(options && options['active-user-email']){
      headers['active-user-email'] = options['active-user-email']
    }else{
      if(localStorage.getItem("cashierDetail")){
        const cashierDetail = JSON.parse(localStorage.getItem("cashierDetail")); 
        let option = {
          "active-user-email" : cashierDetail.email
        };
        headers['active-user-email'] = option['active-user-email'];
      }
    }
    if(options && options['active-user-password']){
      headers['active-user-password'] = options['active-user-password']
    }
    
  }catch(err){
    console.log(err);
  }

  
  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers : {...headers,...options.extraHeaders}
  });

  axiosInstance.interceptors.response.use((response) =>
    new Promise((resolve, reject) => {
      resolve(response.data);
    }), (error) => {
      console.error("error -----> ", error);
      if (error && error.response && error.response.status && error.response.status === 401) {
        setReturnURL(options?.role);
        logOutUser(options?.role);
        Swal.fire({
          icon: "error",
          text: (error?.response?.data?.message) || "Session expired, please login again.",
          ...SWAL_SETTINGS,
        });
      }
      // return Promise.reject(error);
      return error;
    }
  );

  return axiosInstance;
};

export default Axios;